(function () {
  var state = window.__makeLoveBrandLoader;

  if (!state || !state.root || !state.root.parentNode) return;

  var root = state.root;
  var number = root.querySelector('.makelove-brand-loader__number');
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var configuredMinimum = parseInt(root.getAttribute('data-min-duration'), 10);
  var minimumDuration = isFinite(configuredMinimum) ? configuredMinimum : 1200;
  var warmUpDuration = 900;
  var finishDuration = 200;
  var holdDuration = 230;
  var exitDuration = 560;
  var hardFinishAt = 2950;
  var loadComplete = document.readyState === 'complete';
  var currentProgress = 0;
  var finishing = false;
  var animationFrame = 0;

  var now = function () {
    return window.performance && performance.now ? performance.now() : Date.now();
  };

  var renderProgress = function (value) {
    currentProgress = Math.max(currentProgress, Math.min(100, value));
    root.style.setProperty('--makelove-loader-progress', String(currentProgress / 100));

    if (number) {
      var rounded = Math.round(currentProgress);
      number.textContent = rounded < 10 ? '0' + rounded : String(rounded);
    }
  };

  var removeLoader = function () {
    window.cancelAnimationFrame(animationFrame);
    window.clearTimeout(state.hardTimeout);
    state.unlockPage();

    if (root.parentNode) root.parentNode.removeChild(root);
    delete window.__makeLoveBrandLoader;
  };

  var exitLoader = function () {
    root.classList.add(reduceMotion ? 'is-fading' : 'is-exiting');
    window.setTimeout(removeLoader, reduceMotion ? 180 : exitDuration + 40);
  };

  var finish = function () {
    if (finishing || !root.parentNode) return;
    finishing = true;

    if (reduceMotion) {
      renderProgress(100);
      window.setTimeout(exitLoader, 80);
      return;
    }

    var finishStartedAt = now();
    var finishStartedFrom = currentProgress;

    var finishFrame = function (frameNow) {
      var ratio = Math.min((frameNow - finishStartedAt) / finishDuration, 1);
      var eased = 1 - Math.pow(1 - ratio, 3);
      renderProgress(finishStartedFrom + (100 - finishStartedFrom) * eased);

      if (ratio < 1) {
        animationFrame = window.requestAnimationFrame(finishFrame);
      } else {
        renderProgress(100);
        window.setTimeout(exitLoader, holdDuration);
      }
    };

    animationFrame = window.requestAnimationFrame(finishFrame);
  };

  var warmUpFrame = function (frameNow) {
    if (finishing || !root.parentNode) return;

    var elapsed = frameNow - state.startedAt;
    var warmRatio = Math.min(elapsed / warmUpDuration, 1);
    var eased = 1 - Math.pow(1 - warmRatio, 3);
    var waitingProgress = elapsed > warmUpDuration
      ? Math.min(96, 92 + ((elapsed - warmUpDuration) / 700))
      : 92 * eased;

    renderProgress(waitingProgress);

    var earliestFinishAt = Math.max(
      warmUpDuration,
      minimumDuration - finishDuration - holdDuration - exitDuration
    );

    if ((loadComplete && elapsed >= earliestFinishAt) || elapsed >= hardFinishAt) {
      finish();
      return;
    }

    animationFrame = window.requestAnimationFrame(warmUpFrame);
  };

  var handlePageHide = function () {
    if (window.__makeLoveBrandLoader) window.__makeLoveBrandLoader.removeImmediately();
  };

  window.addEventListener('load', function () {
    loadComplete = true;
  }, { once: true });

  window.addEventListener('pagehide', handlePageHide, { once: true });
  window.addEventListener('pageshow', function (event) {
    if (event.persisted && window.__makeLoveBrandLoader) {
      window.__makeLoveBrandLoader.removeImmediately();
    }
  });

  renderProgress(0);
  window.requestAnimationFrame(function () {
    root.classList.add('is-visible');
    animationFrame = window.requestAnimationFrame(warmUpFrame);
  });
})();
